
const digest = '50642ed7bf6a6effce5332b21cfc9365e0671ec2e9db21798107885ed88dd885';
const classes = {"wrapper":"_wrapper_mbamn_1","controls":"_controls_mbamn_7"};
const css = `._wrapper_mbamn_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_mbamn_1 ._controls_mbamn_7 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  